import React, { useState, useEffect, useRef } from 'react';
import imageMesa from '../../asses/not-found/table-removebg-preview.png';
import { tables } from '../../Variables';
// import { Socket } from 'socket.io-client';
import { useParams } from 'react-router-dom';
import { io } from 'socket.io-client';
import logo from './../../asses/not-found/logo-removebg-preview.png'

function Tables({setConsoleAdmin, consoleAdmin, setNewRequestWaiter, newRequestWaiter, receiveOrders, setReceiveOrders, tablesArray, setTablesArray }) {
  const [actualTable, setActualTable] = useState([]);
  const [visibilityCheck, setVisibilityCheck] = useState(false);
   const [contOrder, setContOrder] = useState(0)
   const mesaId = useParams()
// comprobation content receiveorders

// useEffect(() => {
// console.log("estructura de receiveorders: "  +  JSON.stringify(receiveOrders))
// }, [receiveOrders])


// DETALLES DE CADA MESA

  const showCheck = (table) => {
    localizeOrder(String(table));
    setVisibilityCheck(true);
  };

  // LOCALIZAR ORDEN
  const localizeOrder = (tableNumber) => {
    setConsoleAdmin(prevState => [...prevState,"Tabla seleccionada:", tableNumber]);
   setConsoleAdmin(prevState => [...prevState,"Órdenes recibidas:", receiveOrders]);
  
    const order = receiveOrders.filter((order) => {
      // console.log("Comparando con:", order.data.table); // Verifica qué mesa se está comparando
      return order.data.table === tableNumber; 
    });
  
    setConsoleAdmin(prevState => [...prevState,"Órdenes filtradas:", order]);
    setActualTable(order);

    // console.log("data del actual table: " + order)

  };

// ELIMINAR ORDEN
  const deleteOrder = (idOrder) => {
   const newOrders = receiveOrders.filter((order) => {
return order.data.id !== idOrder
   })
   
setReceiveOrders(newOrders)
setContOrder(contOrder + 1)

  }

  useEffect(() => {
    setActualTable(receiveOrders)
  }, [contOrder])


// MAPEO
  const mapeoCheck = () => {
    if (actualTable.length === 0) {
      return <p style={{fontWeight: "bold"}}>No hay órdenes para esta mesa.</p>;
    }

    return (
      <div className='admin-carbuy' id='admin-carbuy-tables'>
        {actualTable.map((orderData, index) => {
           // Verifica la estructura de orderData
          const products = orderData.data.products;
          const { data } = orderData;
          const { id, table } = data; 
          
          return (
            <div key={index}>
              {products && products.length > 0 ? (
                products.map((product, productIndex) => (
                  <div className='impresion-table' key={productIndex} style={{display: "flex", flexDirection: "row"}}>
                    <div>
                    <h4>{product.name}</h4>
                    {/* <p>{product.kcal}</p> */}
                    <p>{product.price} $</p>
                    <img className='img-carbuy' src={product.imagen} />
                    <p>{product.date}</p>
                    {/* <p>Ingredients: {product.ingredients}</p> */}
                    </div><div>
                      <button onClick={() => deleteOrder(id)}>X</button>
                      </div>
                  </div>
                ))
              ) : (
                <div className='container-whithouth-order'>
                  <div className='container-logo-whithouth'>
                  <img src={logo} className='logo-whithouth-order' />
                </div>
                <p className='impresion-table-con' style={{fontWeight: "bold"}} >No hay productos en esta orden.</p>
                
              </div>
              )}
            </div>
            // 'admin-carbuy' id='admin-carbuy-tables'
          );
        })}
      </div>
    );
  };


// LOGICA DEL MESERO 
const [requestWaiter, setRequestWaiter] = useState([{tableNumber: null, StateVisibility: false}]);
 const socketRef = useRef(null);

 // Configuración de socket.io para recibir la solicitud del cliente
// Configuración de socket.io





useEffect(() => {
  socketRef.current = io('https://backend-menue.onrender.com', {
    path: '/socket',
    transports: ['websocket', 'polling'],
  });
  
}, []);


// Función para enviar al mesero
const handleSendWaiter = (tableNumber) => {
    // Deshabilitar el botón del mesero
    setConsoleAdmin(prevState => [...prevState, `enviado mesero a la mesa ${tableNumber}`] )
    socketRef.current.emit('enviar_mesero', tableNumber);
    if(requestWaiter > 0 ){
    setNewRequestWaiter(newRequestWaiter - 1)
  }
    setTablesArray(prevState => 
      prevState.map(table => 
        Number(table.tableNumber) === Number(tableNumber) ? { ...table, StateVisibility: false} : table
      )
    );
    
    setNewRequestWaiter(newRequestWaiter - 1)
};


// COMPARACION MESAS TRAIDAS MEDIANTE WEBSOCKET TABLAS ACTUALES

const tablesWorks = (table) => {
const Tablework = tablesArray.filter((tables) => {
  return tables.tableNumber === table
})
}


  // RETURN CENTRAL

  return (
    

      <div className='container-tables-panel-admin'>
    <div className='grid-container'>
      {tablesArray && tablesArray.map((table, index) =>{ 


       return (


        <div key={index} className='container-mapeo-tables'>
          <button onClick={() => handleSendWaiter(Number(table.tableNumber))} disabled={table.StateVisibility === false} >Mesero</button>
          <div>
          <img src={imageMesa} className='img-mesa' alt={`Mesa ${Number(table.tableNumber)}`} />
          <p>Dispositivos conectados: <span style={{color: "white"}}>{table.numberConects}</span> </p>
          </div>
          <div style={{height: "25px", padding: "2px", marginBottom: "40px"}}>
          <h1>Mesa {Number(table.tableNumber)}</h1>
          </div>
          <button onClick={() => showCheck(Number(table.tableNumber))}>Info</button>
        </div>
      )})}
  
      </div>
      {visibilityCheck && (
        <div className='container-table-impresion-xd'>
          {mapeoCheck()}
        </div>
      )}
    </div>
  );
}

export default Tables;


